export function NotFoundScreen()
{
    return (
        <div className="m-auto">
            <h5 className="fw-bold">Hmm, não encontramos a página que você está tentando acessar</h5>
        </div>
    )
}